var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoluSliderGradCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 534,
    height: 534,
    viewBox: "0 0 534 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.59 1.32223C387.093 -13.2352 518.109 94.0868 532.667 240.59C547.224 387.093 439.902 518.109 293.399 532.667C146.896 547.224 15.8796 439.902 1.32223 293.399C-13.2352 146.896 94.0869 15.8796 240.59 1.32223ZM288.908 488.065C410.787 475.986 500.145 366.96 487.988 245.081C475.831 123.202 366.883 33.844 245.004 46.001C123.124 58.0805 33.7666 167.106 45.9236 288.985C58.0806 410.865 167.029 500.222 288.908 488.065Z",
    fill: "url(#paint0_linear_1334_1023)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.417 137.911C179.578 50.4893 308.659 37.2483 396.081 108.409C483.502 179.57 496.743 308.651 425.583 396.072C354.422 483.494 225.341 496.735 137.919 425.574C50.4977 354.413 37.2567 225.333 108.417 137.911ZM398.946 374.391C458.182 301.604 447.109 194.282 374.4 135.046C301.613 75.8099 194.291 86.8828 135.054 159.592C75.8183 232.379 86.8911 339.701 159.601 398.937C232.388 458.174 339.71 447.101 398.946 374.391Z",
    fill: "url(#paint1_linear_1334_1023)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.921 227.502C137.679 144.184 223.165 94.1622 306.483 115.921C389.801 137.68 439.822 223.165 418.064 306.483C396.305 389.801 310.819 439.823 227.502 418.064C144.184 396.305 94.162 310.819 115.921 227.502ZM392.743 299.824C410.863 230.522 369.204 159.361 299.901 141.241C230.599 123.122 159.438 164.781 141.319 234.083C123.199 303.386 164.858 374.547 234.161 392.666C303.463 410.785 374.624 369.126 392.743 299.824Z",
    fill: "url(#paint2_linear_1334_1023)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.652 313.839C130.789 252.977 159.285 182.513 220.147 156.65C281.009 130.788 351.473 159.283 377.336 220.145C403.198 281.008 374.703 351.472 313.841 377.334C252.979 403.197 182.515 374.701 156.652 313.839ZM358.752 228.044C337.226 177.402 278.609 153.708 227.968 175.234C177.327 196.761 153.632 255.377 175.158 306.018C196.685 356.66 255.302 380.354 305.943 358.828C356.584 337.301 380.278 278.685 358.752 228.044Z",
    fill: "url(#paint3_linear_1334_1023)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.014 348.529C190.025 330.874 167.802 280 185.379 235.012C203.034 190.023 253.907 167.8 298.896 185.377C343.884 202.955 366.108 253.906 348.53 298.894C330.876 343.883 280.002 366.106 235.014 348.529ZM293.553 199.083C256.153 184.448 213.72 202.955 199.085 240.355C184.45 277.755 202.956 320.188 240.356 334.823C277.757 349.458 320.19 330.951 334.825 293.551C349.46 256.151 330.953 213.718 293.553 199.083Z",
    fill: "url(#paint4_linear_1334_1023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1334_1023",
    x1: 532.844,
    y1: 240.643,
    x2: 1.4019,
    y2: 293.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64E7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1334_1023",
    x1: 396.071,
    y1: 108.422,
    x2: 137.903,
    y2: 425.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64E7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1334_1023",
    x1: 306.571,
    y1: 115.853,
    x2: 227.589,
    y2: 417.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64E7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1334_1023",
    x1: 220.135,
    y1: 156.668,
    x2: 313.844,
    y2: 377.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64E7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1334_1023",
    x1: 185.41,
    y1: 234.992,
    x2: 348.559,
    y2: 298.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64E7A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoluSliderGradCircle);
export default __webpack_public_path__ + "static/media/soluSliderGradCircle.06df48b74f40ae9d4334c3f2507d1a7d.svg";
export { ForwardRef as ReactComponent };